import { CopyButtonContainer } from "./CopyButton.styles"
import CopyIcon from "../CopyIcon/CopyIcon"
import Snackbar from "../Snackbar/Snackbar"
import { GRAYSCALE_200 } from "../../styles/colors"
import { useState } from "react"

export type CopyButtonProps = {
    onClick: () => void
    stringToCopy: string
    copiedMessage: string
    color?: string
    borderColor?: string
    backgroundColor?: string
    size?: number
}

const CopyButton = ({
    onClick,
    stringToCopy,
    copiedMessage,
    color = '#000626',
    borderColor = 'transparent',
    backgroundColor = GRAYSCALE_200,
    size = 48
}: CopyButtonProps) => {
    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(stringToCopy)
            setShowSnackbar(true)
            onClick()
        } catch {
            setShowSnackbar(false)
        }
    }

    const handleSnackbarClose = () => {
        setShowSnackbar(false)
    }

    return (
        <>
            <CopyButtonContainer
                type="button"
                aria-label="Copy to clipboard"
                onClick={handleCopy}
                style={{
                    borderColor,
                    backgroundColor,
                    maxWidth: `${size}px`,
                    maxHeight: `${size}px`,
                    padding: `${size / 6}px`
                }}
            >
                <CopyIcon color={color} />
            </CopyButtonContainer>
            <Snackbar
                message={copiedMessage}
                isVisible={showSnackbar}
                onClose={handleSnackbarClose}
                duration={3000}
                textAlign="center"
            />
        </>
    )
}

export default CopyButton
